export default function CompanyTable({ data }) {
  return (
    <div className="card shadow-sm border-0 mt-4">
      <div className="card-body p-0">
        <table className="table align-middle mb-0">
          <thead className="table-light">
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Tags</th>
              <th>Owner</th>
              <th>Contact</th>
              <th>Status</th>
            </tr>
          </thead>

          <tbody>
            {data.map((item) => (
              <tr key={item.id}>
                <td>
                  <div className="d-flex align-items-center gap-2">
                    <img src={item.avatar} alt="micheal"  width="40" className="rounded-circle" />
                    <div>
                      <div className="fw-semibold">{item.name}</div>
                      <small className="text-muted">{item.role}</small>
                    </div>
                  </div>
                </td>

                <td>{item.email}</td>

                <td>
                  <span className="badge bg-primary-subtle text-primary">
                    Collab
                  </span>
                </td>

                <td>
                  <div className="d-flex align-items-center gap-2">
                    <img src={item.avatar}  alt="micheal"  width="40" className="rounded-circle" />
                    <div>
                      <div className="fw-semibold">{item.name}</div>
                      <small className="text-muted">{item.role}</small>
                    </div>
                  </div>
                </td>

                <td>📞 💬 🔗</td>

                <td>
                  <span
                    className={`badge ${
                      item.status === "Active"
                        ? "bg-success-subtle text-success"
                        : "bg-danger-subtle text-danger"
                    }`}
                  >
                    {item.status}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}